import get from 'lodash/get';
import { REDUCERS_NAME } from '../../constants';

const reducerName = REDUCERS_NAME.COURRIERS_DEPARTURE;

export const createLoader = (state) => get(state, `${reducerName}.createLoader`);
export const deleteLoader = (state) => get(state, `${reducerName}.deleteLoader`);
export const error = (state) => get(state, `${reducerName}.error`);
export const getAll = (state) => get(state, `${reducerName}.data`, {});
export const getById = (id) => (state) => get(state, `${reducerName}.data.[${id}]`);
export const loader = (state) => get(state, `${reducerName}.loader`);
export const pagination = (state) => get(state, `${reducerName}.pagination`);
export const updateLoader = (state) => get(state, `${reducerName}.updateLoader`);
